<script>
export default {
  name: 'ComprehensiveApproach',
  components: {
  },
  data () {
    return {
      isMounted: false
      // images: [
      //   {
      //     mobile: './img/visual_closure_vid@0.25x.png',
      //     tablet: './img/visual_closure_vid@0.25x.png',
      //     desktop: './img/visual_closure_vid@0.25x.png',
      //     widescreen: './img/visual_closure_vid@0.25x.png',
      //     fullhd: './img/visual_closure_vid@0.25x.png',
      //     fallback: './img/visual_closure_vid@0.25x.png'
      //   },
      //   {
      //     srcSet: 'img/promo/home/comprehensiveApproach//visual_closure_vid@0.25x.png 768w, img/promo/home/comprehensiveApproach//visual_closure_vid@0.5x.png 1025w'
      //   }
      // ]
    }
  },
  computed: {
    images () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_game@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_game@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_wksheet@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_wksheet@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/visual_closure_vid@0.33x.png 100w, img/promo/home/comprehensiveApproach/visual_closure_vid@0.5x.png 1025w'
        }
      ]
    },
    vidLibImg () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_pr@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_pr@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_coach@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_coach@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_kim@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_kim@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/vidLib_wm@0.33x.png 100w, img/promo/home/comprehensiveApproach/vidLib_wm@0.5x.png 1025w'
        }
      ]
    },
    worksheetImg () {
      return [
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_01@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_01@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_02@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_02@0.5x.png 1025w'
        },
        {
          srcSet: 'img/promo/home/comprehensiveApproach/wksht_03@0.5x.png 100w, img/promo/home/comprehensiveApproach/wksht_03@0.5x.png 1025w'
        }
      ]
    },
    screenSize () {
      return this.$mq
    }
  },
  methods: {
  },
  mounted () {
    this.isMounted = false
  }
}
</script>
<template>
  <article class="comprehensive-approach">
    <header class="container mobile-container">
      <h2 class="text-outline-light section-title-main">Comprehensive Approach</h2>
<!--      <div class="section-subtitle">Round Out Your Treatment Plan with 3 complimentary playlists</div>-->
      <div class="section-subtitle">Round Out Your Treatment Plan with corresponding Worksheets and Videos</div>
    </header>
    <div class="container mobile-container is-size-5 mt-2">
      Our Activities, Worksheets, and Video libraries are tagged, filterable, and searchable by therapy type (among other things).<br>
      It's easy to find and assign the right Worksheets and Videos to compliment your treatment plan.
    </div>
    <section class="container mobile-container mt-6">
      <header>
        <h3 class="sub-section-title">Worksheets Library</h3>
        <div class="is-size-5 has-text-grey-dark">
          Downloadable Worksheets for all ages and abilities
        </div>
      </header>
      <div
        class="worksheet-lib-list"
      >
        <div class="worksheet-lib-item">
          <div class="worksheet-lib-item-image">
            <b-image
              src="img/promo/home/comprehensiveApproach/wksht_01@0.5x.png"
              :srcset="worksheetImg[0].srcSet"
              ratio="317by245"
            />
          </div>
        </div>
        <div class="worksheet-lib-item">
          <div class="worksheet-lib-item-image">
            <b-image
              src="img/promo/home/comprehensiveApproach/wksht_02@0.5x.png"
              :srcset="worksheetImg[1].srcSet"
              ratio="317by245"
            />
          </div>
        </div>
        <div class="worksheet-lib-item">
          <div class="worksheet-lib-item-image">
            <b-image
              src="img/promo/home/comprehensiveApproach/wksht_03@0.5x.png"
              :srcset="worksheetImg[2].srcSet"
              ratio="317by245"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="container mobile-container mt-4">
      <header>
        <h3 class="section-subtitle">Video Library</h3>
        <div class="is-size-5 has-text-grey-dark">
          Add movement to your treatment plan.
        </div>
      </header>
      <div class="video-grid mt-1">
        <div class="video-grid-item">
          <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/primitive_reflexes@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/primitive_reflexes@0.33x.png"
              responsive
              ratio="422by238"
              alt="Primitive Reflexes video library screenshot"
          />
          <div class="video-grid-item-content">
            <h4 class="is-family-semibold is-size-5">
              Primitive Reflexes
            </h4>
            <p class="article-body">
              Professional PR videos created by Patricia Andrich, COVT, OTR/L
            </p>
          </div>
        </div>
        <div class="video-grid-item">
          <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/ovb-coach@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/ovb-coach@0.33x.png"
              responsive
              ratio="422by238"
              alt="OVB Coach video library screenshot"
          />
          <div class="video-grid-item-content">
            <h4 class="is-family-semibold is-size-5">
              OVB Coach
            </h4>
            <p class="article-body">
              Demonstrating how to use therapy equipment and other therapeutic activities at home.
            </p>
          </div>
        </div>
        <div class="video-grid-item">
          <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/we_move@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/we_move@0.33x.png"
              responsive
              ratio="422by238"
              alt="We Move video library screenshot"
          />
          <div class="video-grid-item-content">
            <h4 class="is-family-semibold is-size-5">
              We Move
            </h4>
            <p class="article-body">
              Fun tutorials focusing on using common household objects to work on perceptual skills.
            </p>
          </div>
        </div>
        <div class="video-grid-item">
          <b-image
              class="video-grid-item-image"
              src="/img/promo/home/comprehensiveApproach/kids_in_motion@0.33x.avif"
              src-fallback="/img/promo/home/comprehensiveApproach/kids_in_motion@0.33x.png"
              responsive
              ratio="422by238"
              alt="Kids In Motion video library screenshot"
          />
          <div class="video-grid-item-content">
            <h4 class="is-family-semibold is-size-5">
              Kids In Motion
            </h4>
            <p class="article-body">
              Professional Pilates videos demonstrating how to perform various movements focusing on core and balance.
            </p>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<style scoped lang="scss">
.comprehensive-approach {
  display: block;
  //background-color: #F5EBDC;
  background-color: hsl(36,46,93);
  //background-image: linear-gradient(to right, #F5EBDC, $eggshell);
  padding: 2rem 0 2rem 0;
  .worksheet-lib-list {
    display: flex;
    flex-wrap: wrap;
    .worksheet-lib-item {
      width: 14rem;
      margin-bottom: 1rem;
      &:not(:last-child) {
        margin-right: 1rem;
      }
    }
    .worksheet-lib-item-image {
      width: 14rem;
      box-shadow: rgba(0, 0, 0, 0.05) 0 5px 20px;
    }
  }
  .video-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    & .video-grid-item {
      box-shadow: rgba(0, 0, 0, 0.1) 0 10px 50px;
      background-color: $white;
      border-radius: 0.5rem;
      @include tablet {
      }
      @include desktop {
      }
      &-content {
        padding: 1rem;
      }
    }
  }
  .visual-closure {
    &-container {
      background-color: $empty-background;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding: 1rem;
      border-radius: 0.5rem;
      @include tablet {
        justify-content: flex-start;
      }
    }
    &-image {
      width: 12rem;
      &:not(:last-child) {
        margin-bottom: 1rem;
      }
      figcaption {
        text-align: center;
        font-family: $family-semibold;
        color: $feldgrau;
        margin: 0;
        padding: 0;
        font-size: $size-6;
      }
      @include tablet {
        width: 14rem;
        &:not(:last-child) {
          margin-bottom: 0;
          margin-right: 1rem;
        }
      }
    }

  }
}
</style>
